var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item-component"},[_vm._m(0),_c('chart-three',{staticStyle:{"height":"90%"},attrs:{"value":_vm.chartData}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s-item-title"},[_c('h4',{staticClass:"chart-title"},[_c('i',{staticClass:"el-icon-s-grid"}),_vm._v(" 预报到统计人数 ")])])
}]

export { render, staticRenderFns }